import { useContext, useState } from "react";
import styles from "./index.module.scss"
import { CloseOutlined } from '@ant-design/icons';
import Iconfont from '@utils/Iconfont';
import { ColorPicker, message } from "antd";
import { GenerateContext } from "../../../hooks/GenerateContext";

const ColorPalette = (props) => {
    const {
        open,
        onOpenChange,
        value,
        onChange,
        children,
    } = props

    // 颜色选择器
    const handleColorPicker = () => {
        if (!window.EyeDropper) return message.warning("您的浏览器不支持颜色选择器")
        const eyeDropper = new EyeDropper()
        eyeDropper.open().then((res) => {
            const rgba = res.sRGBHex
            onChange(rgba)
        }).catch((err) => {
            message.warning(err.message)
        })
    }

    // 自定义颜色选择器
    const panelRender = (panel, extra) => {
        const components = extra.components
        const {Picker, Presets} = components

        return (
            <div className={styles.PanelRender}>
                <p className={styles.Header}>
                    <span>调色盘</span>
                    <CloseOutlined onClick={() => onOpenChange(false)} />
                </p>
                <Picker />
                <Iconfont
                    type="icon-ColorDropperOutlined"
                    className={styles.ColorPickerIcon}
                    onClick={handleColorPicker}
                />
            </div>
        )
    }
    return (
        <ColorPicker
            rootClassName={styles.ColorPicker}
            panelRender={panelRender}
            value={value}
            open={open}
            trigger="click"
            onOpenChange={onOpenChange}
            destroyOnHidden
            arrow={false}
            disabledAlpha
            disabledFormat
            placement="right"
            onChange={color => onChange(color.toHexString())}
        >
            {children}
        </ColorPicker>
    )
}

export default ColorPalette
